import React from 'react';
// import PropTypes from 'prop-types';
import EditUserAvatarView from '../../../../components/EditUserAvatarView';

const ClientAvatar = () => <EditUserAvatarView isShowSubTitle={false} />;
ClientAvatar.propTypes = {};

export default ClientAvatar;
